export enum RedirectSelectInsurance {
  SelfPackagePage = 'self-package',
  PlanComparisons = 'plan-comparisons'
}
